/**
 * @module actions/EmbeddedBooking
 */
import axios from 'axios'
import {
  API_URL,
  SET_EMBEDDED_BOOKING_CARDATA,
  SET_EMBEDDED_BOOKING_IMAGES,
  SET_EMBEDDED_BOOKING_DAMAGE_COMMENT,
  SET_EMBEDDED_BOOKING_OTHERINFO,
  SET_EMBEDDED_BOOKING_CONTACTINFO,
  SET_EMBEDDED_BOOKING_DATA,
  SET_EMBEDDED_INSURANCE_COMPANIES,
  SET_EMBEDDED_CARRENTAL_ALTERNATIVES
} from '../constants'

/**
 * @description Save embedded booking data using the api
 * @return {Promise} Axios promise
 */
export function saveEmbeddedBooking (data) {
  let url = API_URL + '/EmbeddedBooking/Post/'
  return dispatch => {
    return axios.post(url, data).then(res => {
      dispatch(setEmbeddedBookingData(res.data))
      return res
    })
  }
}

/**
 * @description Get booking portal welcome message
 * @return {Promise} Axios promise
 */
export function getBookingPortalWelcomeMessageFromToken (token) {
  let url = API_URL + '/EmbeddedBooking/GetBookingPortalWelcomeMessage'
  let data = { token: token }
  return dispatch => {
    return axios.post(url, data)
  }
}

export function getBookingPortalRedirectUrlFromToken (token, usageString) {
  let usage = 0
  switch (usageString) {
    case 'bookingportal':
      usage = 1
      break
  }
  let url = API_URL + '/EmbeddedBooking/GetBookingPortalRedirectUrl'
  let data = { token: token, usage: usage }
  return dispatch => {
    return axios.post(url, data)
  }
}

export function setEmbeddedBookingData (data) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_BOOKING_DATA,
      data
    })
  }
}

export function setEmbeddedBookingCardata (carData) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_BOOKING_CARDATA,
      carData
    })
  }
}

export function setEmbeddedBookingImages (images) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_BOOKING_IMAGES,
      images
    })
  }
}

export function setEmbeddedBookingDamageComment (damageComment) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_BOOKING_DAMAGE_COMMENT,
      damageComment
    })
  }
}

export function setEmbeddedBookingOtherInfo (otherInfo) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_BOOKING_OTHERINFO,
      otherInfo
    })
  }
}

export function setEmbeddedBookingContactInfo (contactInfo) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_BOOKING_CONTACTINFO,
      contactInfo
    })
  }
}

export function setEmbeddedInsuranceCompanies (insuranceCompanies) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_INSURANCE_COMPANIES,
      insuranceCompanies
    })
  }
}

export function setEmbeddedCarRentalAlts (carRentalAlts) {
  return dispatch => {
    dispatch({
      type: SET_EMBEDDED_CARRENTAL_ALTERNATIVES,
      carRentalAlts
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/embeddedbooking.js